import React from "react";
import { isDesktop } from "react-device-detect";

class LandingAnimation extends React.Component {
    render() {
        const landingAnimationStyle = {
            width: isDesktop ? undefined : "100%",
            opacity: 0,
            animation: "landing 0.3s forwards",
        };

        const keyframesStyle = `
            @keyframes landing {
                from {
                    transform: translateY(20px);
                    opacity: 0;
                }
                to {
                    transform: translateY(0);
                    opacity: 1;
                }
            }
        `;

        return (
            <div>
                <style>{keyframesStyle}</style>
                <div style={landingAnimationStyle}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default LandingAnimation;